// Forsiden («/»): dashboardet, men ansatte, ledere og administratorer sendes
// til Min side første gang per innlogging (src/lib/landingsside.js).
//
// Valget tas under rendering og leser bare; MarkerLandet merker brukeren etter
// at en side er vist. Da sender ikke et senere klikk på «Dashboard» brukeren
// videre, og en direktelenke teller som landing.
import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { brukernokkel, markerLandet, tilMinSide } from '../lib/landingsside'

export default function Forside({ children }) {
  const { role, appUser, hasPermission } = useAuth()
  if (tilMinSide({ rolle: role, nokkel: brukernokkel(appUser), kanSeMinSide: hasPermission('vaktplan.read') })) {
    return <Navigate to="/min-side" replace />
  }
  return children
}

/** Står i den interne rutegruppen og merker brukeren når en side er vist. */
export function MarkerLandet() {
  const { appUser } = useAuth()
  const nokkel = brukernokkel(appUser)
  useEffect(() => { markerLandet(nokkel) }, [nokkel])
  return null
}
